export type ClimateRiskReportCategory =
  | "climate"
  | "futureHazard"
  | "CRSComponent";

export interface ClimateRiskSspData {
  SSP126Arr: any[];
  SSP245Arr: any[];
  SSP370Arr: any[];
  SSP585Arr: any[];
}

export interface ClimateRiskReportSection {
  category: ClimateRiskReportCategory;
  title: string;
  description?: string;
  sspData: ClimateRiskSspData;
  isEmpty?: boolean;
  emptyReason?: string;
}

export const getClimateRiskLayerLabelKey = (
  category: ClimateRiskReportCategory,
  layerId: string
) => {
  const normalizedLayerId = layerId.includes(".")
    ? layerId.split(".").pop() || layerId
    : layerId;
  const normalizedCategory = (category || "").toLowerCase();
  const layerPrefix = layerId.split(".")[0];
  const normalizedPrefix = (layerPrefix || "").toLowerCase();

  if (
    normalizedCategory === "futurehazard" ||
    normalizedPrefix === "futurehazard"
  ) {
    return `layerId.futureHazard.${normalizedLayerId}`;
  }

  if (
    normalizedCategory === "crscomponent" ||
    normalizedPrefix === "crscomponent"
  ) {
    return `layerId.CRSComponent.${normalizedLayerId}`;
  }

  return `layerId.${normalizedLayerId}`;
};

export const isColorlessClimateRiskCategory = (
  category: ClimateRiskReportCategory
) => category === "CRSComponent";
